export const MOCK_COMPANY_IMAGE = 'https://www.logodesign.net/logo/abstract-arrow-with-financial-bars-76ld.png';

export const MOCK_COMPANY_IMG_OBJ = {
  fileSrc: MOCK_COMPANY_IMAGE,
  fileType: 'image',
  name: 'company ',
};
